import { frameTypesAPI } from "@/views/Frames/Types/api";

export const getAllFrameTypes = async () => {
  try {
    const res = await frameTypesAPI.getList();
    return res?.data;
  } catch (e) {}
};
export const getFrameTypeParamsList = async (frame_type_id) => {
  try {
    const res = await frameTypesAPI.getFrameTypeParamsList(frame_type_id);
    return res?.data;
  } catch (e) {}
};
export const updateFrameLinkParam = async (body) => {
  try {
    const res = await frameTypesAPI.updateFrameLinkParam(body);
    return res?.data;
  } catch (e) {}
};
export const deleteBalance = async (frame_type_id) => {
  try {
    const res = await frameTypesAPI.deleteBalance(frame_type_id);
    return res?.data;
  } catch (e) {}
};
export const onDeleteFrameTypeParam = async (frame_param_link_id) => {
  try {
    const res = await frameTypesAPI.onDeleteFrameTypeParam(frame_param_link_id);
    return res?.data;
  } catch (e) {}
};

export const frameTypesColumns = [
  {
    name: "frame_type_id",
    field: "frame_type_id",
    label: "ID",
    align: "center",
  },
  {
    name: "frame_type_name",
    field: "frame_type_name",
    label: "frame_type_name",
    align: "left",
  },
  {
    name: "action",
    field: "",
    label: "",
    align: "center",
  },
];
